export default __webpack_public_path__ + "media/react/assets/desk-3fe72ed22dac716713b598e950ee8228.svg";